<!-- Sidebar navigation-->
<nav class="sidebar-nav" style="min-height: 65vh">

  <ul id="sidebarnav" [ngClass]="(botTestDropped && showMiniSidebar) ? 'block-sidebarnav' : ''">
    <!-- First level menu -->
    <ng-container *ngFor="let sidebarnavItem of sidebarnavItems; let i = index">
      <br *ngIf="sidebarnavItems.length - 1 == i" />

      <li [class.active]="showMenu === sidebarnavItem.title" *ngIf="sidebarnavItem.roles.includes(auth.user.role.name)"
        [routerLinkActive]="sidebarnavItem.submenu.length != 0 ? '' : 'active'">
        <span class="nav-small-cap" *ngIf="sidebarnavItem.extralink === true">
          {{ sidebarnavItem.title }}
        </span>

        <ng-container>
          <a [routerLink]="sidebarnavItem.class === '' ? [sidebarnavItem.path] : null"
            [ngClass]="[sidebarnavItem.class]" *ngIf="!sidebarnavItem.extralink && sidebarnavItem.submenu.length === 0"
            (click)="addExpandClass(sidebarnavItem.title, i)">
            <i [ngClass]="[sidebarnavItem.icon]"></i>
            <span class="hide-menu">{{ "shared.sidebar." + sidebarnavItem.title | translate }}
              <span *ngIf="sidebarnavItem.label != ''" [ngClass]="[sidebarnavItem.labelClass]">
                {{ sidebarnavItem.label }}</span>
            </span>
          </a>

          <a [ngClass]="[sidebarnavItem.class]" *ngIf="!sidebarnavItem.extralink && sidebarnavItem.submenu.length > 0"
            (click)="addExpandClass(sidebarnavItem.title, i)">
            <i [ngClass]="[sidebarnavItem.icon]"></i>
            <span class="hide-menu">{{ "shared.sidebar." + sidebarnavItem.title | translate }}
              <span *ngIf="sidebarnavItem.label != ''" [ngClass]="[sidebarnavItem.labelClass]">
                {{ sidebarnavItem.label }}</span>
            </span>
          </a>
        </ng-container>

        <!-- Second level menu -->
        <ul class="collapse" *ngIf="sidebarnavItem.submenu.length > 0"
          [ngClass]="{ in: showMenu === sidebarnavItem.title }">

          <li *ngFor="let sidebarnavSubItem of sidebarnavItem.submenu"
            [class.active]="showSubMenu === sidebarnavSubItem.title"
            [routerLinkActive]="sidebarnavSubItem.submenu.length > 0 ? '' : 'active'">

            <ng-container>
              <a [routerLink]="sidebarnavSubItem.submenu.length > 0 ? null : [sidebarnavSubItem.path]"
                [routerLinkActive]="sidebarnavSubItem.submenu.length > 0 ? '' : 'router-link-active'"
                [ngClass]="[sidebarnavSubItem.class]"
                *ngIf="!sidebarnavSubItem.extralink && sidebarnavSubItem.roles.includes(auth.user.role.name) && sidebarnavSubItem.submenu.length === 0"
                (click)="addActiveClass(sidebarnavSubItem.title, i)">
                <i [ngClass]="[sidebarnavSubItem.icon]"></i>
                {{ "shared.sidebar." + sidebarnavSubItem.title | translate }}
              </a>

              <!-- IN CASE LEVEL 3 -->
              <a [ngClass]="[sidebarnavSubItem.class]" [class.active]="showSubMenu === sidebarnavSubItem.title"
                *ngIf="!sidebarnavSubItem.extralink && sidebarnavSubItem.roles.includes(auth.user.role.name) && sidebarnavSubItem.submenu.length > 0"
                (click)="addActiveClass(sidebarnavSubItem.title, i)">
                <i [ngClass]="[sidebarnavSubItem.icon]"></i>
                {{ "shared.sidebar." + sidebarnavSubItem.title | translate }}
              </a>
            </ng-container>

            <!-- Third level menu -->
            <ul class="collapse" *ngIf="sidebarnavItem.submenu.length > 0"
              [ngClass]="{ in: showSubSubMenu === sidebarnavSubItem.title }">

              <li *ngFor="let sidebarnavSubSubItem of sidebarnavSubItem.submenu"
                [class.active]="showSubMenu === sidebarnavSubSubItem.title"
                [routerLinkActive]="sidebarnavSubSubItem.submenu.length > 0 ? '' : 'active'">

                <a [routerLink]="sidebarnavSubSubItem.submenu.length > 0 ? null : [sidebarnavSubSubItem.path]"
                  [routerLinkActive]="sidebarnavSubSubItem.submenu.length > 0 ? '' : 'router-link-active'"
                  [ngClass]="[sidebarnavSubSubItem.class]"
                  *ngIf="!sidebarnavSubSubItem.extralink && sidebarnavSubSubItem.roles.includes(auth.user.role.name)">
                  <i [ngClass]="[sidebarnavSubSubItem.icon]"></i>
                  {{ "shared.sidebar." + sidebarnavSubSubItem.title | translate }}
                </a>
              </li>
            </ul>

          </li>

        </ul>

      </li>

    </ng-container>
  </ul>

  <!-- TEST BOT -->
  <!-- <div [ngClass]="(botTestDropped && showMiniSidebar) ? 'bot-test' : ''">
    <div class="text-center pb-3 mt-5" *ngIf="!showMiniSidebar">
      <div class="btn-group" ngbDropdown placement="bottom" role="group" aria-label="Button group with nested dropdown">
        <button class="btn btn-outline-info btn-test-bot btn-test-{{techSelected?.value}}" ngbDropdownToggle>
          <span class="btn-label" [ngClass]="techSelected?.class">
            <i class="mdi mdi-flask-outline"></i>
          </span>
          {{ "shared.headerNavigation.testBot.button" | translate }}
        </button>

        <div class="drop-transform dropdown-menu" ngbDropdownMenu>
          <ng-container *ngFor="let tech of techTypes">
            <button [ngClass]="validateButtonClass(tech)" ngbDropdownItem (click)="toggleChat(tech?.value)">
              {{tech?.name | translate}}</button>
          </ng-container>
        </div>

      </div>
    </div>

    <div class="pb-3 mt-5" *ngIf="showMiniSidebar">
      <div class="btn-group btn-mini-block" ngbDropdown (openChange)="toggleDrop($event)" placement="right" role="group"
        aria-label="Button group with nested dropdown">
        <button class="btn btn-sm btn-outline-info btn-mini btn-test-{{techSelected?.value}} ml-3"
          [ngClass]="techSelected?.class" ngbDropdownToggle>
          <i class="mdi mdi-flask-outline"></i>
        </button>

        <div class="dropdown-menu" #testDropDown ngbDropdownMenu>
          <ng-container *ngFor="let tech of techTypes">
            <button [ngClass]="validateButtonClass(tech)" ngbDropdownItem (click)="toggleChat(tech?.value)">
              {{tech.name | translate}}
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </div> -->
  <!-- end TEST BOT -->
</nav>
<!-- End Sidebar navigation -->
